/**
 * service request status enum
 */
export enum ServiceRequestStatusEnum {
  PENDING = 'Pending',
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
  NOT_STARTED = 'Not Started',
  EN_ROUTE = 'Enroute',
  DROPPED_OFF = 'Dropped Off',
  COMPLETED = 'Completed',
  CANCELLED_WITH_ZERO_MOVEMENT = 'Cancelled no cost',
  CANCELLED_WITH_POSITIVE_MOVEMENT = 'Cancelled with cost',
  CANCELLED = 'Cancelled',
  ACCEPTED = 'Accepted',
  PENDING_CANCELLATION = 'Pending Cancellation',
  PICKED_UP = 'Picked up',
  ON_SCENE = 'On-Scene',
  ON_STANDBY = 'On Standby',
  REPOSITIONING = 'Repositioning',
  IN_POSITION = 'In Position',
  ON_BOARD = 'On-board',
  WHEELS_UP = 'Wheels Up',
  LANDED = 'Landed',
}
